import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./template.vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { Icon } from "../icon/Icon";

@Component({
  name: "ImageEditor",
  mixins: [template],
  components: {
    Cropper,
    MgsIcon: Icon,
  },
})
export class ImageEditor extends Vue {
  $refs!: {
    cropper: Cropper;
  };

  @Prop({
    default: () => ({
      aspectRatio: 16 / 9,
      width: 0,
      height: 0,
      left: 0,
      top: 0,
      rotation: 0,
    }),
  })
  value;

  @Prop({ type: String, required: true }) image!: string;

  defaultTransforms() {
    return {
      rotate: this.value.rotation,
    };
  }

  defaultPosition(args) {
    const { left, top } = this.value;
    return {
      top,
      left,
    };
  }

  defaultSize({ imageSize, visibleArea }) {
    const { height, width } = this.value;
    const temp = {
      width: width ? width : (visibleArea || imageSize).width / 2,
      height: height ? height : (visibleArea || imageSize).height / 2,
    };
    return temp;
  }

  rotate(rotation: number) {
    const result = (this.value.rotation + rotation) % 360;

    this.$emit("input", {
      ...this.value,
      rotation: result === -0 ? 0 : result,
    });
    this.$refs.cropper.rotate(rotation);
  }

  change({ coordinates }) {
    console.log("change: ", {
      ...this.value,
      ...coordinates
    })
    this.$emit("input", {
      ...this.value,
      ...coordinates,
    });
  }

  setRatio(aspectRatio: number) {
    this.$emit("input", {
      ...this.value,
      aspectRatio,
    });

    this.$nextTick(() => {
      this.$emit('input', {
        ...this.value,
        ...this.$refs.cropper.getResult().coordinates
      })
    });
  }
}
